module.exports = __webpack_public_path__ + "files/rea sink.76798a67d16cd6827b06d1c1ec1ec176.pdf";